document.addEventListener('click', function(e) {
const btn = e.target.closest('.upsell__toggle-switch');
 if(!btn) return;
  var insurance_added =  btn.closest('cart-drawer-insurance').getAttribute('data-selected');
    if(insurance_added == 'true'){
        btn.closest('cart-drawer-insurance').setAttribute('data-selected',false);
        var product_id = btn.closest('cart-drawer-insurance').getAttribute('data-id');
        toggleInsurance(product_id, false);
    }else{
        btn.closest('cart-drawer-insurance').setAttribute('data-selected',true);
        var product_id = btn.closest('cart-drawer-insurance').getAttribute('data-id');
        toggleInsurance(product_id, true);
    }
})
async function toggleInsurance(variantId, isSelected) {
  const url = isSelected ? '/cart/add.js' : '/cart/change.js';

  const body = isSelected
    ? { id: variantId, quantity: 1 }
    : { id: variantId, quantity: 0 };

  await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body)
  });

  // Refresh cart drawer
  updateCartDrawer();
}
function updateCartDrawer(){
fetch('/?sections=mini-cart')
  .then(res => res.json())
  .then(data => {
      console.log(data);
    const newHTML = data['mini-cart'];

    const parser = new DOMParser();
    const doc = parser.parseFromString(newHTML, 'text/html');

    const newDrawer = doc.querySelector('cart-drawer');
    const currentDrawer = document.querySelector('cart-drawer');

    if (newDrawer && currentDrawer) {
      currentDrawer.innerHTML = newDrawer.innerHTML;
        function animateCounter(element, duration) {
          const end = parseInt(element.dataset.value);
          const startTime = performance.now();
          const updateCounter = (currentTime) => {
            const progress = Math.min(
              (currentTime - startTime) / duration,
              1
            );
            element.value = Math.floor(progress * end);
            if (progress < 1) requestAnimationFrame(updateCounter);
          };
          requestAnimationFrame(updateCounter);
        }
        animateCounter(document.getElementById("counterInput"), 2000);  
    }
  });
}